module.exports = __webpack_public_path__ + "img/long-handed-inserter-platform.95739ecb.png";